import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import Women from "./Pages/Women";
import Blog from "./Pages/Blog";
import Singleblog from "./Pages/Singleblog";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Login from "./Pages/Login";
import Cart from "./Components/Cart";
import Checkout from "./Pages/Checkout";
import Boysshoes from "./Pages/Boysshoes";
import Mens from "./Pages/Mens";
import Gentsshoes from "./Items/Gentsshoes";
import Handbags from "./Items/Handbags";
import Ladiesshoes from "./Items/Ladiesshoes";
import Girlsshoes from "./Items/Girlsshoes";
import Womenclothes from "./Items/Womenclothes";
import Menclothes from "./Items/Menclothes";
import Boysclothes from "./Items/Boysclothes";
import Girlsclothes from "./Items/Girlsclothes";
import Jacket from "./Pages/Products.js/Jacket";
import Printedredshirt from "./Items/Printedredshirt";
import Bluesolidjacket from "./Pages/Products.js/Bluesolidjacket";
import Batawomenblackheels from "./Pages/Products.js/Batawomenblackheels";
import Printedsweatshirtunisexstyle from "./Pages/Products.js/Printedsweatshirtunisexstyle";
import Cigarettetrouse from "./Pages/Products.js/Cigarettetrouser";
import SleevesZipperJacketwithHoodiesforBoys from "./Pages/Products.js/SleevesZipperJacketwithHoodiesforBoys";
function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          {/* Website Header Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/women" element={<Women />} />
          <Route path="/mens" element={<Mens />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/singleblog" element={<Singleblog />} />
          {/* All Items in Single Page */}

          {/* 1st Boys Items */}
          <Route path="/boysshoes" element={<Boysshoes />} />
          <Route path="/boysclothes" element={<Boysclothes />} />
          {/* 1st Girls Items */}
          <Route path="/girlsshoes" element={<Girlsshoes />} />
          <Route path="/girlsclothes" element={<Girlsclothes />} />

          {/* 1st Mens Items */}

          <Route path="/gentsshoes" element={<Gentsshoes />} />
          <Route path="/mensclothes" element={<Menclothes />} />
          {/* 1st Womens Items */}
          <Route path="/ladisshoes" element={<Ladiesshoes />} />
          <Route path="/womenclothes" element={<Womenclothes />} />
          {/* Hand Bags */}
          <Route path="/handbags" element={<Handbags />} />

          {/* Single Page Boys Clothes */}
          <Route path="/jacket" element={<Jacket />} />
          <Route path="/printedredshirt" element={<Printedredshirt />} />
          <Route path="/bluesolidwomensjacket" element={<Bluesolidjacket />} />
          <Route
            path="/batawomenblackheels"
            element={<Batawomenblackheels />}
          />
          <Route
            path="/printedsweatshirtunisexstyle"
            element={<Printedsweatshirtunisexstyle />}
          />
          <Route path="/cigarettetrouse" element={<Cigarettetrouse />} />
          <Route path="/sleeveszipperjacketwithhoodiesforboys" element={<SleevesZipperJacketwithHoodiesforBoys />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
